__turbopack_context__.v({
  "applyBtn": "filter-overlay-module__9if4ea__applyBtn",
  "backdrop": "filter-overlay-module__9if4ea__backdrop",
  "body": "filter-overlay-module__9if4ea__body",
  "closeBtn": "filter-overlay-module__9if4ea__closeBtn",
  "fadeIn": "filter-overlay-module__9if4ea__fadeIn",
  "footer": "filter-overlay-module__9if4ea__footer",
  "header": "filter-overlay-module__9if4ea__header",
  "panel": "filter-overlay-module__9if4ea__panel",
  "resetBtn": "filter-overlay-module__9if4ea__resetBtn",
  "slideDown": "filter-overlay-module__9if4ea__slideDown",
  "slideUp": "filter-overlay-module__9if4ea__slideUp",
  "title": "filter-overlay-module__9if4ea__title",
});
